import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { BASE_PATH, FORM_ACTION } from "../../core/router/types/routerTypes";
import { SecondaryButton } from "../Buttons/components/ActionButton";

export type ImportButtonProps = {
    resourceName: string;
    isDisabled: boolean;
    callback?: () => void;
};

export const ImportButton: FC<ImportButtonProps> = ({ resourceName, isDisabled, callback }) => {
    const navigate = useNavigate();
    const onClick = () => navigate(`${BASE_PATH}/${resourceName}/${FORM_ACTION.IMPORT}`);

    return (
        <SecondaryButton name="import_button" onClick={callback || onClick} disabled={isDisabled}>
            {i18n.t("button.import")}
        </SecondaryButton>
    );
};
